import firebase from 'firebase';
import {firestore, query, collection, where, getAll} from 'firebase/firestore';
import {db, auth, storage} from '../db';


// global err function
function err(e) {
    return {success: false, error: e};
  }

/* global achivement maps*/

//append a title for any new field 
const titleMap = [
    "Login Streak",
    "Join Games",
    "Complete your Profile",
    "Submit Surveys"
]

// append a description for any new field. //
const strMap = [
    (n) => `Login ${n} day${n !== 1 ? 's' : ''} in a row!`,
    (n) => `Get added to ${n} unique project${n !== 1 ? 's!' : '!'}`,
    `Let developers learn about you!`,
    (n) => `Complete ${n} survey${n !== 1 ? 's!' : '!'}`
]

/* append a threshold map for any new field. These values determine the requirements for each 
        achievement progression. Use [] for a field that does not have progression */
const thrMap = [
    [2, 5, 10, 20, 50],
    [1, 5, 10, 20, 50],
    [],
    [1, 5, 10, 20, 50]
]

/* get achivement data from profile and package into achievement objects for displaying*/
async function getAchievements(testerId) {
    return new Promise((resolve, reject) => {
        db.collection("PlayTester").doc(testerId).get()
        .then(doc => {
            if (!doc.exists) { // user doesn't exist, send error
                console.log("user doesn't exist");
                reject({ success: false, error: "user does not exist" });
            }

            const testerData = doc.data();
            if (!testerData) {
                reject({ success: false, error: "No data available for this user" });
                return;
            }
            const loginStreak = testerData.loginStreak; 
            // We define achievement static data here since these lists will not become large. This allows us to avoid
            // unnecesary firestore reads

            /* some values such as loginStreak have seperate values for current vs best (so far). We define current here
               use "" if there is no such value for the achivement. */
            const progMap = [
                loginStreak,
                -1,
                -1,
                -1
            ]

            const achievementData = {
                stat1: testerData.bestStreak,  
                stat2: testerData.projectsJoined,
                stat3: testerData.completeProfile,
                stat4: testerData.surveysCompleted
                //append any field you also want to include here. Its value must be an array, integer or boolean
            };
            let completedAchievements = []; 
            let incompletedAchievements = []; 
            
            Object.keys(achievementData).forEach((field, index) => {
                const value = achievementData[field];

                if (typeof value === "boolean") {
                    //console.log(`${field} : ${value}`);
                    if (value) {
                        completedAchievements.push({
                            title: titleMap[index],
                            description: strMap[index],
                            completed: true,
                            progression: "",
                            percentage: 100,
                            level: "Complete"
                        });
                    } else {
                        incompletedAchievements.push({
                            title: titleMap[index],
                            description: strMap[index],
                            completed: false,
                            progression: "None",
                            percentage: 0
                        });
                    }
                } 
                else { 
                    if (value == undefined) {
                        var count = 0;
                    }
                    else if (Array.isArray(value)) {
                        var count = value.length;
                    } else { // Then it is a number
                        var count = parseInt(value);
                    }
                    //console.log(count);
                    let progressionVal = progMap[index];
                    if (progressionVal === -1) {
                        progressionVal = count;
                    }
                    let map = thrMap[index];
                    let threshold = map.findIndex(x => x > count);
                    if (threshold === -1) { //Then all achievements are completed
                        completedAchievements.push({
                            title: titleMap[index],
                            description: strMap[index](map[map.length - 1]),
                            completed: true,
                            progression: "",
                            percentage: 100,
                            level: "Complete"
                        });

                    } else if (threshold === 0) { // no Achievements completed
                        incompletedAchievements.push({
                            title: titleMap[index],
                            description: strMap[index](map[0]),
                            completed: false,
                            progression: `${progressionVal }  / ${map[0]}`,
                            percentage: Math.floor(100 * progressionVal / map[0])
                        });

                    } else {
                        incompletedAchievements.push({ // Achievement to be completed (next in progression)
                            title: titleMap[index],
                            description: strMap[index](map[threshold]),
                            completed: false,
                            progression: `${progressionVal }  / ${map[threshold]}`,
                            percentage: Math.floor(100 * progressionVal / map[threshold])
                        });
                        completedAchievements.push({ // Achievement in progression that was most recently completed
                            title: titleMap[index],
                            description: strMap[index](map[threshold - 1]),
                            completed: true,
                            progression: "",
                            percentage: 100,
                            level: `Tier ${threshold}`
                        });
                    }
                }

            });
            resolve({ success: true, data1: completedAchievements, data2: incompletedAchievements })
        })
        .catch(e => reject(err(e)));
    });
}


async function setAchievementCount(testerData) {
        try {
            const achievementData = {
                stat1: testerData.bestStreak,  
                stat2: testerData.projectsJoined,
                stat3: testerData.completeProfile,
                stat4: testerData.surveysCompleted
            };
            let achievementCount = 0;
            //console.log(achievementCount);

            Object.keys(achievementData).forEach((field, index) => {
                const value = achievementData[field];

                if (typeof value === "boolean") {
                    if (value) {
                        achievementCount += 1;
                    } 
                } 
                else { 
                    if (value == undefined) {
                        var count = 0;
                    }
                    else if (Array.isArray(value)) {
                        var count = value.length;
                    } else { // Then it is a number
                        var count = parseInt(value);
                    }

                    let map = thrMap[index];
                    let threshold = map.findIndex(x => x > count);
                    if (threshold >= 0) { //Then all achievements are completed
                        achievementCount += threshold;
                    } else { // all achievements are completed
                        achievementCount += thrMap.length;
                    }
                }
            });

            //console.log(achievementCount);
            return achievementCount;
        } catch (error) {
            console.error("Error updating achievements", error);
            return 0; 
        }
    }

// returns true if data hits a threshold value for given achivement field.
async function isComplete(achievementTitle, count) {
    try {
        let isComplete = false;

        for (let index = 0; index < titleMap.length; index++) {
            // Note the index should be aligned with all maps
            if ((titleMap[index] === achievementTitle) && thrMap[index].includes(count)) { 
                isComplete = true;
                break; //Can only match 1 achievement so we can ignore the rest.
            }
        }
        return isComplete;
    } catch (error) {
        console.error("Error getting achievement update info", error);
        return false; 
    }
}


  
export default {
    getAchievements,
    setAchievementCount,
    isComplete,
  }

  


// WEBPACK FOOTER //
// ./src/Firestore/Achievements.js